<div class="bg-image" [class.icreate-bg-image]="'cloud'">
    <img class="splash-logo" />
    <h1 class="title">iCreate</h1>
    <div class="sign-in">
        <h1>Welcome to iCreate</h1>
        <p>お名前とメールアドレスを入力してください / Please enter your name and email:</p>

        <form class="login-form" (ngSubmit)="onSubmit()">
            <input class="login-input" type="text" name="name" placeholder="Name / お名前" [(ngModel)]="name" />
            <input
                class="login-input"
                type="email"
                name="email"
                placeholder="Email / メールアドレス"
                [(ngModel)]="email" />

            <button class="sign-in-button" type="submit">サインイン / Sign in</button>
        </form>
    </div>
</div>
